import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GLOBAL } from 'src/app/services/global';
import { HomeComponent } from '../../home/home.component';
import { ClaveUnicaComponent } from '../../claveunica/claveunica.component';
@Component({
  selector: "page-auxUrl",
  templateUrl: "auxUrl.component.html",
  styleUrls: ["./auxUrl.component.css"]
})

export class AuxUrlComponent {
  public filedomSeguimientoUrl = GLOBAL.filedomSeguimientoUrl;
  public acotado = GLOBAL.acotado;
  public nombreMuni = GLOBAL.nombreMuni;
  public pruebaPrototipo = GLOBAL.pruebaPrototipo;
  public espedienteLinea = ["Ingreso de expedientes (no disponible)", "Seguimiento de expedientes"]
  constructor(private dialog: MatDialog, private _router: Router) {

  }

  sign(tipo) {
    //  alert(tipo);
    if (sessionStorage.getItem("identity-domCloud")) {
      this.dialog.closeAll();

      if (tipo == 'seguimiento_expediente') {
        console.log("expediente 1");
        this._router.navigate([`/seguimiento-expedientes`]);

      } else if (tipo == 'expediente') {

        this._router.navigate([`/seguimiento-expedientes`]);
      }
    } else {
      this.dialog.closeAll();
      
      if (tipo == 'seguimiento_expediente') {
        this.dialog.open(ClaveUnicaComponent, { data: "/seguimiento-expedientes" })
        //this._router.navigate([`/seguimiento-expedientes`]);
      } else if (tipo == 'expediente') {
        this.dialog.open(ClaveUnicaComponent, { data: "/seguimiento-expedientes" })
        //this._router.navigate([`/seguimiento-expedientes`]);

      }
    }
  }

  // else {

  //   if (tipo == 'seguimiento_expediente') {
  //     console.log("expediente 2");
  //     localStorage.setItem("navdomcloud", 'expedientes')
  //     this.dialog.open(HomeComponent, {
  //       data: {
  //         url: 'expedientes'
  //       }
  //     })
  //   } else if (tipo == 'seguimiento_expediente') {
  //     // console.log("seguimiento expediente 2");
  //     localStorage.setItem("navdomcloud", 'seguimiento_expediente')
  //     window.open(`${GLOBAL.seguimientoSolicitudes}`, "_blank")

  //   }

  cerrar_vista() {
    this._router.navigate([`/inicio`]);
  }
  /*sign(){
      if(sessionStorage.getItem("identity-domCloud") && sessionStorage.getItem("token-domCloud")){
          this.dialog.closeAll();
          this._router.navigate([`/expedientes`]);
  
        } else {
          localStorage.setItem("navdomcloud", 'expedientes')
          this.dialog.open(HomeComponent,{
            data: {
              url: 'expedientes'
            }
          })
        }
        }*/
}
